export default {
    API_ENDPOINT: 'https://murmuring-lowlands-61113.herokuapp.com/api',
    TOKEN_KEY: 'nowplaying-client-auth-token',
    API_KEY: '4ac5392bc939c102a89ae2c2fd81ed8d'
  }  

  //http://localhost:8000/api
  //'4ac5392bc939c102a89ae2c2fd81ed8d'
